import React, { useState } from 'react';
import { useI18n } from '../../i18n';
import TryOnPreviews from './TryOnPreviews';
import TryOnInfo from './TryOnInfo';
import UserPhotos from './UserPhotos';

export default function MediaLibrary() {
  const { t } = useI18n();
  const [tab, setTab] = useState('tryons');

  return (
    <div className="ct-media-library-page">
      <div className="ct-profile-tabs nav nav-pills" role="tablist" aria-label={t('photos.title')}>
        <button
          type="button"
          className={`nav-link ${tab === 'tryons' ? 'active' : ''}`}
          onClick={() => setTab('tryons')}
          role="tab"
          aria-selected={tab === 'tryons'}
        >
          <i className="ph ph-magic-wand"></i>
          <TryOnInfo label={t('tryonGallery.title')} />
        </button>
        <button
          type="button"
          className={`nav-link ${tab === 'photos' ? 'active' : ''}`}
          onClick={() => setTab('photos')}
          role="tab"
          aria-selected={tab === 'photos'}
        >
          <i className="ph ph-images-square"></i>
          {t('photos.title')}
        </button>
      </div>

      {tab === 'photos' ? <UserPhotos embedded /> : <TryOnPreviews />}
    </div>
  );
}
